import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";

const MOBILE_BREAKPOINT = 930;

function getInitialOpenState(): boolean {
    if (typeof window === "undefined") return true;
    return window.innerWidth > MOBILE_BREAKPOINT;
}

type State = {
    isOpen: boolean;
};

export const SeSidebarStore = signalStore(
    { providedIn: "root" },
    withState<State>({
        isOpen: getInitialOpenState(),
    }),
    withMethods((store) => ({
        toggle() {
            patchState(store, { isOpen: !store.isOpen() });
        },
        close() {
            patchState(store, { isOpen: false });
        },
        open() {
            patchState(store, { isOpen: true });
        },
    })),
);

export type SeSidebarStore = InstanceType<typeof SeSidebarStore>;
